import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const StyledSeparator = styled(Box)(({ theme }) => ({
  height: 8,
  cursor: "row-resize",
  marginTop: 4,
  marginBottom: 4,
  background: theme.palette.grey[300],
  position: "relative",
  borderRadius: 10,
  flexShrink: 0,
  transition: "height 0.1s, background 0.1s",
  "&:hover": {
    height: 10,
    background: theme.palette.grey[400],
    "& .separator-grip": {
      background: theme.palette.grey[700],
    },
  },
  "& .separator-grip": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 40,
    height: 3,
    background: theme.palette.grey[500],
    borderRadius: 2,
    transition: "background 0.1s",
  },
}));

interface Props {
  onMouseDown: (e: React.MouseEvent) => void;
  onDoubleClick: () => void;
}

export const VerticalDragSeparator = ({
  onMouseDown,
  onDoubleClick,
}: Props) => (
  <StyledSeparator onMouseDown={onMouseDown} onDoubleClick={onDoubleClick}>
    <div className="separator-grip" />
  </StyledSeparator>
);
